import ChannelStatusPage from "@/components/channels/ChannelStatusPage";
import { outboundDeck } from "./outboundExplainer";

/** Help Genie Outbound channel page — product intro and SSO handoff into Outbound. */
const OutboundChannelPage = () => <ChannelStatusPage appId="outbound" deck={outboundDeck} />;

export default OutboundChannelPage;
